precision highp float;

uniform float uTime;
uniform float uProgress;
varying vec2  vUv;
varying float vElev;

void main() {
  // Palette: void → emerald → gold
  vec3 c1 = vec3(0.024, 0.078, 0.058); // --c-void
  vec3 c2 = vec3(0.043, 0.239, 0.180); // --c-emerald
  vec3 c3 = vec3(0.788, 0.635, 0.294); // --c-gold

  float t = clamp(vElev * 1.5 + 0.5, 0.0, 1.0);
  vec3 col = mix(c1, c2, t);
  col = mix(col, c3, smoothstep(0.55, 0.9, t) * 0.4);

  // Per-pixel hash noise — film grain feel
  float n = fract(sin(dot(vUv * 1000.0 + uTime, vec2(12.9898, 78.233))) * 43758.5453);
  col += (n - 0.5) * 0.025;

  // Soft radial vignette around the center
  vec2 p = vUv - 0.5;
  col *= smoothstep(1.1, 0.4, length(p));

  // Subtle warmup as the hero progresses (sun rising metaphor)
  col = mix(col, col * vec3(1.08, 1.03, 0.95), uProgress);

  gl_FragColor = vec4(col, 1.0);
}
